import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from 'src/app/_services/toaster.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ExhibitService } from 'src/app/_services/generatedServices';
import { ExhibitDesignerViewModel, UpdateExhibitViewModel, FileType } from 'src/app/_models/generatedModels';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { Enums } from 'src/app/_models/generatedEnums';
import { AnalyticsService } from 'src/app/_services/analytics.service';

@Component({
  selector: 'bxl-exhibit-designer',
  templateUrl: 'exhibit-designer.component.html',
})
export class ExhibitDesignerComponent implements OnInit, OnDestroy {
  initialized = false;
  submitComplete: Promise<{}> | undefined;
  public formGroup: FormGroup;
  bannerImageChangedEvent: any = '';
  logoImageChangedEvent: any = '';
  bannerModalImage: any;
  logoModalImage: any;
  uploadUrl: string;
  bannerCroppedImage: any = '';
  logoCroppedImage: any = '';
  bannerInitialCroppedImage: string;
  logoInitialCroppedImage: string;
  private routeSubscription: Subscription;
  exhibitId: number;
  exhibit: ExhibitDesignerViewModel;
  bannerAssetPath: string;
  logoAssetPath: string;
  FileTypeEnum = Enums.FileTypeEnum;

  constructor(private analyticsService: AnalyticsService, private route: ActivatedRoute, private location: Location, private exhibitService: ExhibitService, private router: Router, private toastr: ToasterService, public auth: AuthenticationService, private modalService: NgbModal, private fb: FormBuilder) {}

  ngOnInit(): void {
    this.uploadUrl = '/api/uploadMaterials';
    this.routeSubscription = this.route.paramMap.subscribe((param) => {
      this.exhibitId = parseInt(param.get('id'));

      this.exhibitService.getExhibitById(this.exhibitId).subscribe((exhibit) => {
        this.exhibit = exhibit;
        this.analyticsService.setTitleAndLogPageView('Exhibit Desinger - ' + exhibit.title);
        this.setupForm();
      });
    });
  }

  setupForm(): any {
    this.formGroup = this.fb.group({
      title: [this.exhibit.title, [Validators.required, Validators.maxLength(255)]],
      subtitle: [this.exhibit.subtitle, [Validators.required, Validators.maxLength(255)]],
      website: [this.exhibit.website, [Validators.required, Validators.maxLength(255)]],
      conferenceName: [this.exhibit.conferenceName, [Validators.required, Validators.maxLength(255)]],
      description: [this.exhibit.description],
      published: [this.exhibit.published],
      introVideoAssetPath: [this.exhibit.introVideoAssetPath],
      materials: this.fb.array([]),
    });

    this.loadMaterials();

    this.bannerAssetPath = this.exhibit.bannerAssetPath;
    this.logoAssetPath = this.exhibit.logoAssetPath;

    this.initialized = true;
  }

  public onSave(preview: boolean) {
    if (!this.formGroup.valid) {
      this.formGroup.markAllControlsDirty();
      this.toastr.error('Please fill out all required fields', 'Error');
      console.log(this.formGroup);
      return;
    }

    this.submitComplete = new Promise((resetButton:any, reject) => {
      const formData: UpdateExhibitViewModel = Object.assign({}, this.exhibit, this.formGroup.value);

      if (this.bannerInitialCroppedImage !== this.bannerCroppedImage) {
        formData.bannerBase64Image = this.bannerCroppedImage;
      } else {
        formData.bannerBase64Image = null;
      }

      if (this.logoInitialCroppedImage !== this.logoCroppedImage) {
        formData.logoBase64Image = this.logoCroppedImage;
      } else {
        formData.logoBase64Image = null;
      }

      this.exhibitService.updateExhibit(this.exhibitId, formData).subscribe(
        (job) => {
          if (preview) {
            this.router.navigate(['/exhibitor-booth', this.exhibitId, 'preview']);
          } else {
            this.location.back();
          }
          this.toastr.success('Exhibit Updated', 'Success');
          resetButton();
        },
        (error) => resetButton()
      );
    });
  }

  cancel() {
    this.location.back();
  }

  loadMaterials() {
    let materials = this.formGroup.get('materials') as FormArray;

    if (!this.exhibit.materials || this.exhibit.materials.length === 0) {
      return;
    }

    this.exhibit.materials.forEach((material) => {
      let materials = this.formGroup.get('materials') as FormArray;
      materials.push(
        this.fb.group({
          description: [material.description, Validators.required],
          fileType: [FileType[material.fileType], Validators.required],
          blobPath: [material.blobPath, Validators.required],
          fileName: [material.fileName],
        })
      );
    });
  }

  removeMaterial(index: number): void {
    let materials = this.formGroup.get('materials') as FormArray;
    materials.removeAt(index);
  }

  addMaterial(): void {
    let materials = this.formGroup.get('materials') as FormArray;
    materials.push(this.createMaterial());
  }

  createMaterial(): FormGroup {
    return this.fb.group({
      description: ['', Validators.required],
      fileType: ['', Validators.required],
      blobPath: ['', Validators.required],
    });
  }

  editBannerImage(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg', backdrop: 'static' }).result.then(
      (result) => {
        this.bannerCroppedImage = this.bannerModalImage;
        console.log('here');
      },
      (reason) => {
        console.log('here2');
      }
    );
  }

  editLogoImage(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg', backdrop: 'static' }).result.then(
      (result) => {
        this.logoCroppedImage = this.logoModalImage;
        console.log('here');
      },
      (reason) => {
        console.log('here2');
      }
    );
  }

  bannerFileChangeEvent(event: any): void {
    this.bannerImageChangedEvent = event;
  }

  bannerImageCropped(event: ImageCroppedEvent) {
    this.bannerModalImage = event.base64;
    console.log(this.bannerInitialCroppedImage === this.bannerCroppedImage);
  }

  bannerImageLoaded() {
    console.log('loaded');
    // show cropper
  }

  bannerLoadImageFailed() {
    // show message
  }

  logoFileChangeEvent(event: any): void {
    this.logoImageChangedEvent = event;
  }

  logoImageCropped(event: ImageCroppedEvent) {
    this.logoModalImage = event.base64;
    console.log(this.logoInitialCroppedImage === this.logoCroppedImage);
  }

  logoImageLoaded() {
    console.log('loaded');
    // show cropper
  }

  logoLoadImageFailed() {
    // show message
  }

  successEventHandler(evt, i) {
    const controlArray = <FormArray>this.formGroup.get('materials');
    controlArray.controls[i].get('blobPath').setValue(evt.response.body.name);
    console.log(evt);
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }
}
